<template>
    <div class="wrap">
        <SectionTitle text="Weekly Ranking" class="title" />

        <ul class="gridRanking">
            <li v-for="(item, index) in weeklyRanking" :key="index">
                <a :href="switchItemURL(item)" v-on="canHover ? hoverHandlers(item, index) : {}" ref="items">
                    <div class="rank">{{ index + 1 }}</div>

                    <img :src="thumbSrc(item)" :data-first-thumb="item.first_thumb || '0'" :data-second-thumb="item.second_thumb || '00'" alt="" class="img" v-show="!item.gif" ref="itemImages" />
                    <img :src="`https://thumbnail.image.rakuten.co.jp/@0_mall/auc-rodeo/cabinet/${item.image}-0.gif`" alt="" class="img" v-if="item.gif" />

                    <div class="brand">{{ item.brand }}</div>
                    <div class="price">{{ taxIn(item.price) }}</div>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import SectionTitle from '@/components/SectionTitle.vue'

export default {
  name: 'WeeklyRanking',

  components: { SectionTitle },

  data () {
    return {
      windowWidth: (typeof window !== 'undefined') ? window.innerWidth : 1524, // 表示件数計算用の現在幅
      canHover: false, // PC等ホバー可能端末のみ true
      hoverMql: null, // hover可否判定用 MediaQueryList
      onHoverChange: null // hover可否変更時のコールバック
    }
  },

  computed: {
    // 画面幅に応じた表示件数
    displayCount () {
      const w = this.windowWidth
      if (w <= 722) return 20 // @media screen and (max-width: 722px)
      if (w <= 963) return 21 // @media screen and (min-width: 723px) and (max-width: 963px)
      if (w <= 1523) return 20 // @media screen and (min-width: 964px) and (max-width: 1523px)
      if (w <= 2286) return 20 // @media screen and (min-width: 1524px) and (max-width: 2286px)
      return 20 // @media screen and (min-width: 2287px)
    },

    // 週ランキングを表示件数に切り出し
    weeklyRanking () {
      return this.$store.state.json.week.slice(0, this.displayCount)
    }
  },

  methods: {
    // 初期表示用サムネURL（first_thumb優先）
    thumbSrc (item) {
      const first = item.first_thumb || '0'
      return `https://thumbnail.image.rakuten.co.jp/@0_mall/auc-rodeo/cabinet/${item.image}-${first}.jpg`
    },

    // 1枚目/2枚目サムネURL生成
    thumbUrl (item, which) {
      const first = item.first_thumb || '0'
      const second = item.second_thumb || '00'
      const thumb = (which === 'second') ? second : first
      return `https://thumbnail.image.rakuten.co.jp/@0_mall/auc-rodeo/cabinet/${item.image}-${thumb}.jpg`
    },

    // hover可能時のみ mouseenter/leave を付与
    hoverHandlers (item, index) {
      return {
        mouseenter: () => this.itemMouseOver(item, index),
        mouseleave: () => this.itemMouseOut(item, index)
      }
    },

    // ホバーで2枚目へ切替（GIF/スマホは対象外）
    itemMouseOver (item, index) {
      if (!this.canHover || item.gif) return
      const imgDom = this.$refs.itemImages && this.$refs.itemImages[index]
      if (!imgDom) return
      imgDom.src = this.thumbUrl(item, 'second')
    },

    // ホバー解除で1枚目へ戻す
    itemMouseOut (item, index) {
      if (!this.canHover || item.gif) return
      const imgDom = this.$refs.itemImages && this.$refs.itemImages[index]
      if (!imgDom) return
      imgDom.src = this.thumbUrl(item, 'first')
    },

    // hover可能端末か判定（スマホでのhover誤動作を回避）
    updateCanHover () {
      this.canHover = !!(
        window.matchMedia &&
        window.matchMedia('(hover: hover) and (pointer: fine)').matches
      )
    }
  },

  mounted () {
    this._onResize = () => { this.windowWidth = window.innerWidth } // 画面幅変更を監視
    window.addEventListener('resize', this._onResize, { passive: true })

    this.onHoverChange = () => this.updateCanHover() // hover可否の変化に追従
    this.updateCanHover()

    if (window.matchMedia) {
      this.hoverMql = window.matchMedia('(hover: hover) and (pointer: fine)') // hover判定を監視
      if (this.hoverMql.addEventListener) {
        this.hoverMql.addEventListener('change', this.onHoverChange)
      } else if (this.hoverMql.addListener) {
        this.hoverMql.addListener(this.onHoverChange)
      }
    }
  },

  beforeDestroy () {
    window.removeEventListener('resize', this._onResize) // リスナー解除

    if (this.hoverMql) {
      if (this.hoverMql.removeEventListener) {
        this.hoverMql.removeEventListener('change', this.onHoverChange)
      } else if (this.hoverMql.removeListener) {
        this.hoverMql.removeListener(this.onHoverChange)
      }
      this.hoverMql = null
    }
    this.onHoverChange = null // 参照クリア
  }
}
</script>

<style lang="scss" scoped>
.gridRanking {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    text-transform: uppercase;
    border-top: 1px solid #dddddd;
    border-left: 1px solid #dddddd;

    @media screen and (max-width: 722px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media screen and (min-width: 723px) and (max-width: 963px) {
        grid-template-columns: repeat(3, 1fr);
    }

    @media screen and (min-width: 964px) and (max-width: 1523px) {
        grid-template-columns: repeat(4, 1fr);
    }

    @media screen and (min-width: 1524px) and (max-width: 2286px) {
        grid-template-columns: repeat(5, 1fr);
    }

    @media screen and (min-width: 2287px) {
        grid-template-columns: repeat(5, 1fr);
    }

    >li {
        padding: 30px;
        font-size: 13px;
        text-align: left;
        border-right: 1px solid #dddddd;
        border-bottom: 1px solid #dddddd;

        @media screen and (max-width: 722px) {
            padding: 15px;
            padding: 15px 15px 23px;
        }

        @media screen and (min-width: 723px) and (max-width: 963px) {}

        @media screen and (min-width: 964px) and (max-width: 1523px) {}

        @media screen and (min-width: 1524px) and (max-width: 2286px) {}

        @media screen and (min-width: 2287px) {}

        a {
            position: relative;
            display: block;
        }

        .rank {
            position: absolute;
            top: 5px;
            left: 5px;
            width: 20px;
            height: 20px;
            font-size: 12px;
            line-height: 19px;
            color: #969696;
            text-align: center;
            background-color: #ffffff;
            border: 1px solid #cccccc;
            border-radius: 100%;
        }
    }

    .img {
        width: 100%;
    }

    .brand {
        padding: 14px 0 6px;

        @media screen and (max-width: 722px) {
            padding: 12px 0 6px;
            padding: 11px 0 4px;
            padding: 10px 0 4px;
        }
    }
}
</style>
